import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mcb-not-found',
  templateUrl: './not-found.component.html'
})
export class PortalNotFoundComponent {
  constructor(private router: Router) {
  }

  gotoHome() {
    this.router.navigate(['/master/dashboard']);
  }
}
